import React from 'react';
import { MenuItem, TextField } from '@mui/material';

import { IUseTimeEntryOptionsResult } from 'components/CallScribe/useTimeEntryOptions';
import usePaperStyles from 'components/CallScribe/paperStyles';

export interface ITimeEntryPickersProps {
  fields: IUseTimeEntryOptionsResult;
  fieldClassName?: string;
}

const TimeEntryPickers: React.FC<ITimeEntryPickersProps> = ({ fields, fieldClassName }) => {
  const paper = usePaperStyles();
  const fieldClass = [paper.field, fieldClassName].filter(Boolean).join(' ');
  return (
    <>
      <TextField
        className={fieldClass}
        label="Work type"
        size="small"
        variant="outlined"
        select
        fullWidth
        disabled={fields.loading || fields.workTypeChoices.length === 0}
        value={fields.workType ?? ''}
        onChange={e => { fields.setWorkType(String(e.target.value)); }}
        InputLabelProps={{ shrink: true }}
        SelectProps={{ displayEmpty: true }}
        helperText={fields.workTypeHelper}
      >
        <MenuItem value="">Use my PSA&apos;s default</MenuItem>
        {fields.workTypeChoices.map(o => (
          <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
        ))}
      </TextField>

      <TextField
        className={`${fieldClass} ${paper.fullRow}`}
        label="Billing"
        size="small"
        variant="outlined"
        select
        fullWidth
        disabled={fields.loading || fields.billingChoices.length === 0}
        value={fields.billingType ?? ''}
        onChange={e => { fields.setBillingType(String(e.target.value)); }}
        InputLabelProps={{ shrink: true }}
        SelectProps={{ displayEmpty: true }}
        helperText={fields.billingHelper}
      >
        <MenuItem value="">
          {fields.billingDefaultLabel
            ? `Use my PSA's default (${fields.billingDefaultLabel})`
            : 'Use my PSA’s default'}
        </MenuItem>
        {fields.billingChoices.map(o => (
          <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
        ))}
      </TextField>
    </>
  );
};

export default TimeEntryPickers;
